import { ChangeDetectionStrategy, Component, inject, OnInit, effect } from '@angular/core';
import { AuthService } from './services/auth.service';
import { AppShellComponent } from './components/app-shell/app-shell.component';
import { UserPlanStore } from './store/user-plan.store';
import { UserStore } from './store/user/user.store';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppShellComponent],
  template: `
    @defer {
      <app-shell />
    } @placeholder {
      <main class="main-content" aria-busy="true" aria-live="polite">
        Loading...
      </main>
    }
  `
})
export class App implements OnInit {
  private authService = inject(AuthService);
  private userPlanStore = inject(UserPlanStore);
  private userStore = inject(UserStore);

  constructor() {
    // Track whether the plan has been loaded for the current authenticated session
    let hasLoadedPlanForSession = false;

    // Load user plan when authentication state changes to authenticated
    // Only load once per authenticated session to avoid redundant API calls
    effect(() => {
      const isAuthenticated = this.userStore.isAuthenticated();
      const isLoading = this.userPlanStore.loading();

      // When the user is not authenticated, reset the per-session flag and store
      if (!isAuthenticated) {
        hasLoadedPlanForSession = false;
        this.userPlanStore.resetStore();
        return;
      }

      // When the user becomes authenticated and the plan has not yet been loaded
      // Also check if a load is not already in progress to prevent concurrent requests
      if (!hasLoadedPlanForSession && !isLoading) {
        // Load the user plan and entitlements
        this.userPlanStore.loadPlan();
        hasLoadedPlanForSession = true;
      }
    });
  }

  ngOnInit(): void {
    this.authService.init();
  }
}
